export default "__VITE_ASSET__mNdw9Jhf__"